<div class="form-group">
  <div class="avalista-card">
    <div class="avalista-card_card">
      <div>
        <span class="avalista-card_title">{{ title }}</span>

        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="onClickRemove()">
          <span aria-hidden="true">&times;</span>
        </button>
        <button
          *ngIf="!hasAnyEdit"
          type="button"
          class="close avalista-card_btn-edit"
          aria-label="Edit"
          (click)="onClickEdit()">
          <span class="glyphicon glyphicon-pencil"></span>
        </button>
      </div>
      <div class="avalista-card_info">
        <dl class="avalista-card_info_label">
          <dt>Nome: </dt>
          <dd>{{ nomeAvalista }}</dd>
        </dl>
      </div>
      <div class="avalista-card_info">
        <dl class="avalista-card_info_label">
          <dt>CPF: </dt>
          <dd>{{ cpfAvalista | cpf }}</dd>
        </dl>
      </div>
    </div>
  </div>
</div>
